<template>
  <div>
    <h4>Demandes de validations</h4>

    <div v-if="readyToRender && validationRequests.data.length > 0">
      <pagination 
        v-if="this.paginationNeeded" 
        :totalPages="this.totalPages" 
        :currentPage="this.currentPage" 
        @click="getPageOnClick"
      ></pagination>

      <table class="table table-condensed table-detailed search-table">
        <thead>
          <th>Type</th>
          <th>Statut</th>
          <th>Création</th>
          <th>Mise à jour</th>
          <th>Demandeur</th>
          <th></th>
        </thead>

        <tbody>
          <template v-for="(validationRequest, idx) in validationRequests.data" >
            <tr :key="'request-' + idx">
              <td>{{ validationRequest.included.type.attributes.display_name }}</td>
              <td>{{ getEnumTranslatedValue('validation_request_status', validationRequest.attributes.status) }}</td>
              <td>{{ validationRequest.attributes.created_at | moment-date }}</td>
              <td>{{ validationRequest.attributes.updated_at | moment-date }}</td>
              <td>
                <a v-if="validationRequest.included.creating_user" :href="'mailto:' + validationRequest.included.creating_user.attributes.email">
                  {{ validationRequest.included.creating_user.attributes.email }}
                </a>
                <span v-else>Utilisateur supprimé</span>
              </td>
              <td>
                <router-link 
                  v-if="validationRequest.attributes.status == 'pending'"
                  :to="{ name: 'single-demand', params: { id: validationRequest.id } }" 
                  class="btn btn-complete"
                >
                  <span>Résoudre</span>
                </router-link>
                
                <button 
                  v-if="!['contract-option-creation', 'contract-option-termination'].includes(validationRequest.included.type.attributes.name)"
                  @click="toggleDetails(validationRequest.id)"
                  class="btn btn-complete"
                >
                  <i class="fa fa-caret-down" v-if="!isToggled(validationRequest.id)"></i>
                  <i class="fa fa-caret-up" v-if="isToggled(validationRequest.id)"></i>
                  Détails
                </button>
              </td>
            </tr>

            <demand-details 
              v-if="isToggled(validationRequest.id)"
              :key="'request-detail-'+idx"  
              :demand="validationRequest" 
              :index="idx"
            ></demand-details>
          </template>
        </tbody>
      </table>

      <pagination 
        v-if="this.paginationNeeded" 
        :totalPages="this.totalPages" 
        :currentPage="this.currentPage" 
        @click="getPageOnClick"
      ></pagination>
    </div>

    <div v-else>
      <hr>
      
      <div class="alert alert-info">
          <i class="fa fa-info-circle"></i> Aucune demande de validation n'a été réalisée pour ce client
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex"
import Pagination from "components/Pagination"
import DemandDetails from "components/Demands/DemandDetails"

export default {
  name: "ValidationRequests",

  components: {
    Pagination,
    DemandDetails
  },

  data () {
    return {
      readyToRender: false,
      details: [],
    }
  },

  computed: {
    ...mapState('customerV2', ['validationRequests']),

    paginationNeeded() {
      if (!this.validationRequests.hasOwnProperty('meta')) {
        return false
      }

      return this.validationRequests.meta.total > this.validationRequests.meta.per_page ? true : false
    },

    currentPage() {
      if (!this.validationRequests.hasOwnProperty('meta')) {
        return 1
      }

      return this.validationRequests.meta.current_page == 0 
        ? 1 
        : this.validationRequests.meta.current_page - 1
    },

    totalPages() {
      return this.validationRequests.hasOwnProperty('meta') ? this.validationRequests.meta.last_page : 1
    }
  },

  created() {
    let params = {
      customerId: this.$route.params.id,
      filter: {
        is_parent: 1
      }, 
      with: "type,creating_user",
    }

    this.getCustomerValidationRequests(params)
      .then(() => this.readyToRender = true)
  },

  methods: {
    ...mapActions('customerV2', ['getCustomerValidationRequests']),

    getPageOnClick(event) {
      if (event + 1 <= this.totalPages) {
        this.readyToRender = false
        this.details = []
        
        let params = {
          customerId: this.$route.params.id,
          filter: {
            is_parent: 1
          }, 
          with: "type,creating_user",
          page: event + 1
        }

        this.getCustomerValidationRequests(params)
          .then(() => this.readyToRender = true)
      }
    },

    toggleDetails(validationRequestId) {
      if (this.isToggled(validationRequestId)) {
        this.details = _.filter(this.details, id => id != validationRequestId)
      } else {
        this.details.push(validationRequestId)
      }
    },

    isToggled(validationRequestId) {
      return (_.find(this.details, id => id == validationRequestId) != undefined)
    }
  }
}
</script>


// WEBPACK FOOTER //
// client/components/Customer/ValidationRequests/ValidationRequests.vue